import {
  SET_ERROR_LIST,
  SET_ERROR_PAGE_TOTAL,
  SET_ERROR_QUERY,
  SET_ERROR_PAGE_SIZE,
  SET_ERROR_PAGE_NUM,
  SET_ERROR_SEARCHING,
  // 渲染作业错误信息
  SET_RENDER_ERROR_LIST,
  SET_RENDER_ERROR_PAGE_TOTAL,
  SET_RENDER_ERROR_QUERY,
  SET_RENDER_ERROR_PAGE_SIZE,
  SET_RENDER_ERROR_PAGE_NUM,
  SET_RENDER_ERROR_SEARCHING,
} from './mutation-types.js'
import api from '@/api'
import {objectTrim} from '@/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  code: '',              // [str option] 错误码
  desDescriptionCn: '',  // [str option] 问题描述
  desSolutionCn: '',     // [str option] 方案描述
  isOpen: '',            // [int option] 是否开启
  // orderBy: 0,            // [int option] 开启降序或者升序排列，0 默认为降序, 1 为升序
  type: '',              // [int option] 错误码类型
  isIgnore: '',          // [int option] 是否可忽略
  isRepair: '',          // [int option] 是否可修复
  languageFlag: '',      // [int option] 语言
  orderByCode: '',
  orderByUpdateTime: '',
})

const initRenderQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  desDescription: '',  // [str option] 问题描述
  desSolution: '',     // [str option] 方案描述
  isOpen: '',            // [int option] 是否开启
  isShow: '',            // [int option] 是否用户展示
  type: '',              // [int option] 错误码类型
  languageFlag: '',      // [int option] 语言
  cgId: '',              // 软件
  orderByUpdateTime: '',
})

const state = {
  searching: false,
  initQuery: initQuery(),
  error: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  renderSearching: false,
  initRenderQuery: initRenderQuery(),
  renderingError: {
    list: [],
    listPageTotal: 0,
    query: initRenderQuery(),
  },
}

const mutations = {
  [SET_ERROR_LIST] (state, payload) {
    state.error.list = payload
  },
  [SET_ERROR_PAGE_TOTAL] (state, payload) {
    state.error.listPageTotal = payload
  },
  [SET_ERROR_QUERY] (state, payload) {
    state.error.query = {
      ...state.error.query,
      ...payload,
    }
  },
  [SET_ERROR_PAGE_SIZE] (state, payload) {
    state.error.query.pageSize = payload
  },
  [SET_ERROR_PAGE_NUM] (state, payload) {
    state.error.query.pageNum = payload
  },
  [SET_ERROR_SEARCHING] (state, payload) {
    state.searching = payload
  },
  // 渲染作业错误信息
  [SET_RENDER_ERROR_LIST] (state, payload) {
    state.renderingError.list = payload
  },
  [SET_RENDER_ERROR_PAGE_TOTAL] (state, payload) {
    state.renderingError.listPageTotal = payload
  },
  [SET_RENDER_ERROR_QUERY] (state, payload) {
    state.renderingError.query = {
      ...state.renderingError.query,
      ...payload,
    }
  },
  [SET_RENDER_ERROR_PAGE_SIZE] (state, payload) {
    state.renderingError.query.pageSize = payload
  },
  [SET_RENDER_ERROR_PAGE_NUM] (state, payload) {
    state.renderingError.query.pageNum = payload
  },
  [SET_RENDER_ERROR_SEARCHING] (state, payload) {
    state.renderSearching = payload
  },
}

const actions = {
  async getErrorList ({commit, state}) {
    try {
      let params = {
        ...objectTrim(state.error.query),
      }
      commit(SET_ERROR_SEARCHING, true)
      let {data: {items, total}} = await api.deployApi.getErrorList(params)
      commit(SET_ERROR_SEARCHING, false)
      commit(SET_ERROR_LIST, items)
      commit(SET_ERROR_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_ERROR_LIST, [])
      commit(SET_ERROR_PAGE_TOTAL, 0)
    }
  },
  async initErrorList ({dispatch}) {
    await dispatch('setPageQuery', state.initQuery)
    await dispatch('getErrorList')
  },
  setPageQuery ({commit}, payload) {
    commit(SET_ERROR_QUERY, payload)
  },
  setPageSize ({commit, dispatch}, payload) {
    commit(SET_ERROR_PAGE_NUM, 1)
    commit(SET_ERROR_PAGE_SIZE, payload)
    dispatch('getErrorList')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_ERROR_PAGE_NUM, payload)
    dispatch('getErrorList')
  },
  async addError ({dispatch}, payload) {
    let data = await api.deployApi.addError(payload)
    dispatch('getErrorList')
    return data
  },
  async editError ({dispatch}, payload) {
    let data = await api.deployApi.editError(payload)
    dispatch('getErrorList')
    return data
  },
  async delError ({dispatch}, payload) {
    let data = await api.deployApi.delError(payload)
    dispatch('getErrorList')
    return data
  },
  // 渲染作业错误信息
  async getRenderErrorList ({commit, state}) {
    try {
      let params = {
        ...objectTrim(state.renderingError.query),
      }
      commit(SET_RENDER_ERROR_SEARCHING, true)
      let {data: {items, total}} = await api.deployApi.getRenderErrorList(params)
      commit(SET_RENDER_ERROR_SEARCHING, false)
      commit(SET_RENDER_ERROR_LIST, items)
      commit(SET_RENDER_ERROR_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_RENDER_ERROR_LIST, [])
      commit(SET_RENDER_ERROR_PAGE_TOTAL, 0)
    }
  },
  async initRenderErrorList ({dispatch}) {
    await dispatch('setRenderPageQuery', state.initRenderQuery)
    await dispatch('getRenderErrorList')
  },
  setRenderPageQuery ({commit, dispatch}, payload) {
    commit(SET_RENDER_ERROR_QUERY, payload)
  },
  setRenderPageSize ({commit, dispatch}, payload) {
    commit(SET_RENDER_ERROR_PAGE_NUM, 1)
    commit(SET_RENDER_ERROR_PAGE_SIZE, payload)
    dispatch('getRenderErrorList')
  },
  setRenderPageNum ({commit, dispatch}, payload) {
    commit(SET_RENDER_ERROR_PAGE_NUM, payload)
    dispatch('getRenderErrorList')
  },
  async addRenderError ({dispatch}, payload) {
    let data = await api.deployApi.addRenderError(payload)
    dispatch('getRenderErrorList')
    return data
  },
  async editRenderError ({dispatch}, payload) {
    let data = await api.deployApi.editRenderError(payload)
    dispatch('getRenderErrorList')
    return data
  },
  async delRenderError ({dispatch}, payload) {
    let data = await api.deployApi.delRenderError(payload)
    dispatch('getRenderErrorList')
    return data
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
